var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('v-button',{staticClass:"btn-primary",attrs:{"working":_vm.loading},nativeOn:{"click":function($event){return _vm.update()}}},[_vm._v("\n    "+_vm._s(_vm.label || "Update")+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }